<form class="contact-form" novalidate (ngSubmit)="submitForm()" [formGroup]="applyForm">
    <div class="two-input-cols-desktop">
        <!-- Will stack these fields on mobile -->
        <div class="form-group" [ngClass]="{ 'required': !firstNameControl.touched || firstNameControl.hasError('required') }">
            <label for="email" class="form-input-label">First Name</label>
            <input matInput [formControl]="firstNameControl" [errorStateMatcher]="matcher" class="form-control">

            @if (firstNameControl.touched && firstNameControl.hasError('required')) {
                <mat-error>First Name is <strong>required</strong></mat-error>
            }  
        </div>


        <div class="form-group" [ngClass]="{ 'required': !lastNameControl.touched || lastNameControl.hasError('required') }">
            <label for="email" class="form-input-label">Last Name</label>
            <input matInput [formControl]="lastNameControl" [errorStateMatcher]="matcher" class="form-control">

            @if (lastNameControl.touched && lastNameControl.hasError('required')) {
                <mat-error>Last Name is <strong>required</strong></mat-error>
            }  
        </div>
    </div>


    <div class="form-group" [ngClass]="{ 'required': !emailControl.touched || emailControl.hasError('required') }">
        <label for="email" class="form-input-label">Email</label>
        <input type="email" matInput [formControl]="emailControl" [errorStateMatcher]="matcher" placeholder="Ex. pat@example.com" class="form-control">

        @if (emailControl.touched && emailControl.hasError('required')) {
            <mat-error>A valid email address <strong>required</strong></mat-error>
        }  
    </div>



    <div class="two-input-cols-desktop">
        <div class="form-group" [ngClass]="{ 'required': !phoneControl.touched || phoneControl.hasError('required') }">
            <label for="phone" class="form-input-label">Phone Number</label>
            <input type="text" [mask]="phoneMask" [formControl]="phoneControl" class="form-control">

            @if (phoneControl.touched && phoneControl.hasError('required')) {
                <mat-error>Phone is <strong>required</strong></mat-error>
            }                    
        </div>


        <div class="form-group" [ngClass]="{ 'required': !zipControl.touched || zipControl.hasError('required') }">
            <label for="phone" class="form-input-label">Zip Code</label>
            <input type="tel" [formControl]="zipControl" class="form-control">

            @if (zipControl.touched && zipControl.hasError('required')) {
                <mat-error>Zip Code is <strong>required</strong></mat-error>
            }                    
        </div>
    </div>


    <div class="form-group" [ngClass]="{ 'required': !professionControl.touched || professionControl.hasError('required') }">
        <label for="profession" class="form-input-label">Profession</label>
        
        <mat-select class="form-control" placeholder="Choose Profession" formControlName="profession" name="profession" panelClass="job-profession-select-panel">
            @for (_job of filteredJobTitles; track _job) {
                <mat-option class="job-profession-select-option" [value]="_job?.profession">{{ _job?.name }}</mat-option>
            }
        </mat-select>
        
        @if (professionControl.touched && professionControl.hasError('required')) {
            <mat-error>A profession is <strong>required</strong></mat-error>
        }                  
    </div>


    <div class="form-group">
        <label for="message" class="form-input-label">Comments</label>
        <textarea formControlName="message" class="form-control" rows="4"></textarea>
    </div>


    <div class="upload-wrapper">
        <div class="form-group" [ngClass]="{ 'required': !fileName || resumeFormControl.hasError('required') }">
            <label for="message" class="form-input-label">Upload Resume</label>
            
            <div class="login-register-btn">
                <input type="file" #file style="display: none" (change)="onFilesAdded()" />
                <button type="button" color="primary" matButton="outlined" (click)="addFiles()">Attach File</button>

                @if (fileName && fileName !== '') {
                    <div class="file-item">{{ fileName }}</div>
                }
            </div>
        </div>               
    </div>


    <div class="captcha-submit default-flex">
        <div class="captcha-wrapper">
            <re-captcha
            formControlName="recaptchaField"
            (resolved)="resolved($event)"
            (error)="errored($event)"
            [siteKey]="recaptchaSiteKey"
            ></re-captcha>
        </div>

        <div class="contact-btn-group" role="group" aria-label="Submit Application">
            <button color="primary" matButton="elevated" [disabled]="!applyForm.valid || !verifiedCaptcha">Send My Info</button>
        </div>
    </div>

    <div class="notices">
        <h5>Data and Communication Acknowledgement <span class="required">(Required)</span></h5>

        <div class="card">
            <div class="card-body">

                <div class="form-group consent-block">
                    <h4 class="consent-title">Data and Communication Acknowledgement</h4>
                    <div class="opt-in-checkboxes-row">
                        <mat-checkbox class="optCommunications-checkbox" color="primary" [(ngModel)]="optIntoSms" name="optSms">Opt in for SMS Communication</mat-checkbox>
                        <mat-checkbox class="optCommunications-checkbox" color="primary" [(ngModel)]="optIntoEmailPhone" name="optEmailPhone">Opt in for Email and Phone Calls</mat-checkbox>
                    </div>
                    <p class="optCommunications-description">
                        By checking the box you consent to receive SMS communications from EDU Healthcare regarding job opportunities and related services (including marketing messages) at 
                        the provided number. Msg & Data rates may apply. Msg frequency varies. Reply STOP to opt out and HELP for HELP. Read more in our <a routerLink="/privacy-policy">Terms and Privacy Policy</a>.
                    </p>
                </div>
            </div>
        </div>

        <!--
        <div class="form-group">
            <mat-checkbox class="optCommunications-checkbox" color="primary" [(ngModel)]="optIntoCommunications" name="optCommunications">I consent to the Data and Communication Acknowledgement</mat-checkbox>
        </div>
        -->
    </div>

    <!--
    <div class="notices">
        <p>
            * By providing my phone number to EDU Healthcare, I agree and acknowledge that EDU Healthcare may send text messages to my wireless phone number for any purpose. Message and data rates may apply. Message frequency will vary; you can opt out by replying “STOP.” Please visit our privacy policy for more information on how your data will be handled.
        </p>

        <p>
            Privacy Policy: No mobile information will be shared with third parties or affiliates for marketing or promotional purposes. All the above categories exclude text messaging originator opt-in data and consent; this information will not be shared with third parties.
        </p>
    </div>
    -->
</form> 
